module.exports = __webpack_public_path__ + "static/media/zoomin.ef89181f.svg";